import { ServerProvider } from '$providers/server';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { Events, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-register-code',
  templateUrl: 'register-code.html',
})
export class RegisterCodePage {

  public user: any;
  public code: '';
  public dispNotificados: '';

  constructor(navParams: NavParams, private events: Events,
    private viewProvider: ViewProvider, private serverProvider: ServerProvider) {

    this.user = navParams.get('user');
    this.dispNotificados = navParams.get('dispNotificados');
  }

  public submit() {
    if (!this.code || this.code == '') {
      this.viewProvider.showMessage('- Informe o <b>Código</b>.');
      return;
    }

    let body = {
      operacao: 'VALIDACAO_REGISTRO_VALIDAR',
      cpf: this.user.cpf,
      codigo: this.code
    };

    this.serverProvider.postData(body).subscribe(
      (data) => {
        if (data) {
          this.viewProvider.showToastMessage('Registro validado com sucesso');
          this.events.publish('app:login');
        }
      },
      (error) => { console.error('Erro ao validar registro. ' + error) }
    );
  }

  public resendCode() {
    let body = {
      operacao: 'VALIDACAO_REGISTRO_SOLICITAR',
      cpf: this.user.cpf
    };

    this.serverProvider.postData(body).subscribe(
      (data) => {
        let dispNotificados = '';
        if (data.dispNotificados) {
          data.dispNotificados.forEach(d => dispNotificados += '- ' + d + '<br>');
          this.viewProvider.showMessage('O código de ativação foi enviado para os contatos informados em seu cadastro.');
        } else {
          this.viewProvider.showMessage('Verifique os contatos informados em seu cadastro. O código de ativação pode demorar alguns minutos para ser entregue.');
        }
      },
      (error) => { console.error('Erro ao solicitar reenvio do código de ativação. ' + error) }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/register/register-code/register-code.ts